import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LinkProducerPayload } from '@/domains/producers/sagas/types/linkProducerResponse';
import { ExistingProducerData } from '@/features/serviceModal/components/LinkProducerModal/components/ExistingProducerItem/types';
import { LinkProducerFieldKey, LinkProducerFieldValue, linkProducerInitialState } from './types/linkProducerTypes';
import { LinkEntityTypesEnum } from '../enums/LinkEntityTypesEnum';

const linkProducerSlice = createSlice({
  name: 'linkProducer',
  initialState: linkProducerInitialState,
  reducers: {
    changeLinkProducerType: (state, action: PayloadAction<LinkEntityTypesEnum>) => {
      state.linkProducerType = action.payload;
    },
    updateLinkProducerStepValues: <K extends LinkProducerFieldKey>(
      state,
      action: PayloadAction<{ step: K; value: LinkProducerFieldValue<K> }>,
    ) => {
      const { step, value } = action.payload;
      state.linkProducerSteps[step] = value;
    },
    resetLinkProducerState: () => linkProducerInitialState,
    setUserForProducerLink: (state, action: PayloadAction<ExistingProducerData | null>) => {
      state.userForProducerLink = action.payload;
    },
    setUsersListForProducerLink: (state, action: PayloadAction<ExistingProducerData[] | null>) => {
      state.usersListForProducerLink = action.payload;
    },
    getLinkProducerExistingUserById: (
      _state,
      _action: PayloadAction<{ searchExpression: string; producerGroupId?: number | null }>,
    ) => {},
    linkProducer: (_state, _action: PayloadAction<LinkProducerPayload>) => {},
    setLinkProducerStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isLinkProducerLoading = payload;
    },
  },
  selectors: {
    selectLinkProducerSteps: (state) => state.linkProducerSteps,
    selectUserForProducerLink: (state) => state.userForProducerLink,
    selectUsersListForProducerLink: (state) => state.usersListForProducerLink,
    selectLinkProducerType: (state) => state.linkProducerType,
    selectLinkProducerIsLoading: (state) => state.statuses.isLinkProducerLoading,
  },
});

export const {
  changeLinkProducerType,
  getLinkProducerExistingUserById,
  resetLinkProducerState,
  setUserForProducerLink,
  setUsersListForProducerLink,
  updateLinkProducerStepValues,
  linkProducer,
  setLinkProducerStatus,
} = linkProducerSlice.actions;

export const {
  selectLinkProducerSteps,
  selectUserForProducerLink,
  selectUsersListForProducerLink,
  selectLinkProducerType,
  selectLinkProducerIsLoading,
} = linkProducerSlice.selectors;

export const linkProducerReducer = linkProducerSlice.reducer;
export const linkProducerReducerPath = linkProducerSlice.reducerPath;
